export default __webpack_public_path__ + "static/media/mlr-vid-1.c7ae9e85.mp4";